/* The clickable parts diagram (blocks/aps-collection-diagram.liquid).
 * Model chips hide the parts not for that model and put that model's part number in each row; a badge and its
 * row light each other on hover; a badge picks its row (on a phone it opens the row in a sheet); Zoom opens the
 * drawing larger; #key-N (#diagram-2-key-N on a second drawing) and ?model= in the address open a key and a model. Without this script every badge is
 * a link to its row and every part is shown.
 * One function scope, like every other APS script. */
(() => {
  const phone = () => window.matchMedia('(max-width: 767px)').matches;

  function init(root) {
    const art = root.querySelector('[data-art]');
    const list = root.querySelector('[data-list]');
    const sheet = root.querySelector('[data-sheet]');
    const brand = root.dataset.brand || '';
    const hs = {}, rows = {};
    root.querySelectorAll('.adg-hs').forEach((a) => { hs[a.dataset.key] = a; });
    list.querySelectorAll('.adg-k').forEach((r) => { rows[r.dataset.key] = r; });
    let model = '';

    function setModel(m) {
      model = m || '';
      root.querySelectorAll('.adg-chip').forEach((b) => b.setAttribute('aria-pressed', b.dataset.model === model ? 'true' : 'false'));
      const sel = root.querySelector('[data-model-select]');
      if (sel && sel.value !== model) sel.value = model;
      Object.entries(rows).forEach(([key, r]) => {
        let byModel = {};
        try { byModel = JSON.parse(r.dataset.byModel || '{}'); } catch (e) { byModel = {}; }
        const items = [...r.querySelectorAll('.adg-it')];
        let shown = 0;
        items.forEach((it) => {
          // Models are written as |a|b| (a model can be '1 HP' or 'High Pressure 1F, 1-1/2A'); the first three
          // diagrams were written with spaces between models that have none.
          const raw = it.dataset.models || '';
          const ms = (raw.indexOf('|') >= 0 ? raw.split('|') : raw.split(' ')).filter(Boolean);
          const on = !model || !ms.length || ms.includes(model);
          it.hidden = !on; if (on) shown += 1;
        });
        const pn = model && byModel[model] ? byModel[model] : (r.dataset.partnos || '');
        const small = r.querySelector('[data-pn]');
        if (small) small.textContent = brand + ' ' + pn + (model ? ' ' + root.dataset.for + ' ' + model : '');
        const none = r.querySelector('[data-none]');
        if (none) {
          none.hidden = shown > 0;
          const npn = none.querySelector('[data-none-pn]');
          if (npn) npn.textContent = model && byModel[model] ? byModel[model] : (r.dataset.partnos || '').split(', ')[0];
        }
        const b = hs[key];
        if (b && !b.classList.contains('dim')) b.classList.toggle('out', !!model && shown === 0);
      });
      const u = new URL(window.location.href);
      if (model) u.searchParams.set('model', model); else u.searchParams.delete('model');
      window.history.replaceState(null, '', u.toString());
    }

    function lite(key, on) { hs[key] && hs[key].classList.toggle('lit', on); rows[key] && rows[key].classList.toggle('lit', on); }

    function pick(key, fromBadge) {
      Object.entries(hs).forEach(([k, b]) => b.classList.toggle('on', k === key));
      Object.entries(rows).forEach(([k, r]) => r.classList.toggle('on', k === key));
      const r = rows[key]; if (!r) return;
      if (fromBadge && phone() && sheet) {
        const body = sheet.querySelector('[data-sheet-body]');
        body.innerHTML = ''; const c = r.cloneNode(true); c.removeAttribute('id'); body.appendChild(c);
        sheet.hidden = false; return;
      }
      if (!phone()) list.scrollTop = r.offsetTop - list.offsetTop - 8;
      else r.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }

    root.querySelectorAll('.adg-chip').forEach((b) => b.addEventListener('click', () => setModel(b.dataset.model)));
    const sel = root.querySelector('[data-model-select]');
    if (sel) sel.addEventListener('change', () => setModel(sel.value));
    Object.entries(hs).forEach(([key, a]) => {
      a.addEventListener('mouseenter', () => lite(key, true));
      a.addEventListener('mouseleave', () => lite(key, false));
      a.addEventListener('click', (e) => { e.preventDefault(); pick(key, true); });
    });
    Object.entries(rows).forEach(([key, r]) => {
      r.addEventListener('mouseenter', () => lite(key, true));
      r.addEventListener('mouseleave', () => lite(key, false));
    });
    if (sheet) {
      sheet.querySelector('[data-sheet-x]').addEventListener('click', () => { sheet.hidden = true; });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') sheet.hidden = true; });
    }

    const zoom = root.querySelector('[data-zoom]');
    const ov = root.closest('.s') && root.closest('.s').querySelector('[data-aps-dg-ov]');
    if (zoom && ov) {
      zoom.addEventListener('click', () => {
        const slot = ov.querySelector('[data-ov-art]'); slot.innerHTML = '';
        const a = art.cloneNode(true); const img = a.querySelector('img');
        a.style.setProperty('--adg-zw', Math.round((img.naturalWidth || img.width) * 1.5) + 'px');
        a.querySelectorAll('.adg-hs').forEach((b) => b.addEventListener('click', (e) => {
          e.preventDefault(); ov.hidden = true; pick(b.dataset.key, true);
        }));
        slot.appendChild(a); ov.hidden = false;
      });
      ov.querySelector('[data-ov-x]').addEventListener('click', () => { ov.hidden = true; });
      ov.addEventListener('click', (e) => { if (e.target === ov) ov.hidden = true; });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') ov.hidden = true; });
    }

    const m = new URL(window.location.href).searchParams.get('model');
    if (m && (root.querySelector('.adg-chip[data-model="' + CSS.escape(m) + '"]') || root.querySelector('[data-model-select] option[value="' + CSS.escape(m) + '"]'))) setModel(m);
    // #key-N on the first drawing, #diagram-2-key-N on a second: open the key whose row has that id.
    const h = decodeURIComponent(window.location.hash.slice(1));
    if (h) {
      const key = Object.keys(rows).find((k) => rows[k].id === h);
      if (key) pick(key, false);
    }
  }

  function run() { document.querySelectorAll('[data-aps-dg]').forEach((r) => { if (!r.dataset.ready) { r.dataset.ready = '1'; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
